import {Resolve} from '@angular/router';
import {UserAddress} from '../model/user-address.model';
import {UserAddressInteractor} from '../interactors/user-address.interactor';
import {LoanApplicationInteractor} from '../interactors/loan-application.interactor';
import {Injectable} from '@angular/core';
import {UserInteractor} from '../interactors/user.interactor';

@Injectable()
export class ResidenceProofResolver implements Resolve<{ address: UserAddress, aadhaarLinkedWithMobile: boolean }> {
    constructor(private loanApplicationInteractor: LoanApplicationInteractor, private userAddressInteractor: UserAddressInteractor, private userInteractor: UserInteractor) {

    }

    async resolve(): Promise<{ address: UserAddress, aadhaarLinkedWithMobile: boolean }> {
        const loanApplication = await this.loanApplicationInteractor.get();
        const userAddress = await this.userAddressInteractor.get(loanApplication.addressId);
        const user = await this.userInteractor.get();
        return {address: userAddress, aadhaarLinkedWithMobile: user.aadhaarLinkedWithMobile};
    }

}